import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import "./styles/base.css";
import "./styles/components.css";
import "./styles/screens.css";
import { App } from "./App";

/** 이 앱의 react-query 기본값. **클라이언트가 둘이라 한 곳에서 만든다.** */
function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5_000,
        // 자동 재시도를 켜지 않는다 — 이 제품의 호출은 장당 과금 경로와 이웃해 있다.
        retry: false,
      },
    },
  });
}

/** **세션 질문만 담는 고정 클라이언트.** 셀러의 데이터는 여기 두지 않는다.
 *
 * ⛔ 셀러의 데이터는 `SessionProvider` 가 계정마다 새로 만드는 클라이언트에 담긴다
 * (`createDataClient`). 계정이 바뀌면 그 클라이언트를 통째로 버린다. 같은 클라이언트를
 * `clear()` 로 비우기만 하면, 로그아웃 전에 나간 요청의 `onSuccess`(`setQueryData`)가 끝나며
 * **앞 셀러의 작업을 비운 캐시에 다시 넣는다.** 버린 클라이언트에 넣게 하는 것이 요점이다.
 * 세션 판정이 데이터 클라이언트를 바꾸는 쪽이라 세션 질의까지 거기 두면 판정이 제 발밑을
 * 바꾸게 된다. 그래서 둘로 가른다. */
const sessionClient = createQueryClient();

const container = document.getElementById("root");
if (!container) throw new Error("#root 가 없습니다");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App sessionClient={sessionClient} createDataClient={createQueryClient} />
    </BrowserRouter>
  </StrictMode>,
);
